import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/payout')({
  beforeLoad: () => {
    throw redirect({ to: '/onboarding' });
  },
});
